export default "__VITE_ASSET__BEN_efgB__"